import GridLayout from "react-grid-layout";
import {
  createVehicleMaintenanceDashboardLayoutChangedAction,
  VEHICLE_MAINTENANCE_DASHBOARD_LAYOUT_CHANGED,
} from "../actions/vehicleMaintenanceDashboardLayout";

export interface IVehicleMaintenanceDashboardLayoutState
  extends GridLayout.Layouts {}
export const initialVehicleMaintenanceDashboardLayoutState: IVehicleMaintenanceDashboardLayoutState = {};

export const vehicleMaintenanceDashboardLayoutReducer = (
  previousState: IVehicleMaintenanceDashboardLayoutState = initialVehicleMaintenanceDashboardLayoutState,
  action: ReturnType<
    typeof createVehicleMaintenanceDashboardLayoutChangedAction
  >
) => {
  switch (action.type) {
    case VEHICLE_MAINTENANCE_DASHBOARD_LAYOUT_CHANGED:
      return {
        ...previousState,
        ...action.payload,
      };
  }

  return previousState;
};
